import * as Cesium from "cesium";
import gsap from "gsap";
import { CENTER } from "./effectConfig";

/**
 * 六边形扩散
 * 不用自定义 Material（Cesium 1.143 下带 image 的 rectangle 材质经常全透明），
 * 改用内置 ImageMaterialProperty，与雷达同高度体系。
 */
export default class LightSpread {
  constructor(viewer, options = {}) {
    const ground = options.groundHeight ?? 1110;
    this.viewer = viewer;

    // 以光锥为中心的初始小矩形
    this.params = {
      minlot: CENTER.lng - 0.008,
      minLat: CENTER.lat - 0.006,
      maxlot: CENTER.lng + 0.008,
      maxLat: CENTER.lat + 0.006,
    };

    this.entity = viewer.entities.add({
      rectangle: {
        coordinates: new Cesium.CallbackProperty(() => {
          return Cesium.Rectangle.fromDegrees(
            this.params.minlot,
            this.params.minLat,
            this.params.maxlot,
            this.params.maxLat
          );
        }, false),
        height: ground + 80,
        // 内置材质，transparent 才能出六边形透明底
        material: new Cesium.ImageMaterialProperty({
          image: `${process.env.BASE_URL}texture/hexagon.png`,
          transparent: true,
          color: Cesium.Color.fromCssColorString("#18ffff").withAlpha(0.95),
        }),
        outline: false,
      },
    });

    gsap.to(this.params, {
      minlot: CENTER.lng - 0.06,
      minLat: CENTER.lat - 0.05,
      maxlot: CENTER.lng + 0.06,
      maxLat: CENTER.lat + 0.05,
      duration: 5,
      repeat: -1,
      ease: "linear",
    });

    console.log("[LightSpread] 已创建, height=", ground + 80);
  }

  setVisible(show) {
    this.entity.show = show;
  }
}
